{
  "overridesEnabledBadgeLabel": "上書きオン"
}
